    <mat-card-content>

      <div class="informacao">

        <p class="mark-yellow">
          ⚠️ <b>{{ "conclusao.atencao" | translate }}</b> {{ "conclusao.msg_inscricao_so_sera_efetivada" | translate}}
        </p>

        <ul>
          <li>{{ "conclusao.msg_efetivada1" | translate}}</li>
          <li>{{ "conclusao.msg_efetivada2" | translate}}</li>
          <li>{{ "conclusao.msg_efetivada3" | translate}}</li>
          <li>{{ "conclusao.msg_efetivada4" | translate}}</li>
        </ul>

        <h3>📄 {{ "conclusao.documentacao" | translate }}</h3>
        <p>
          {{ "conclusao.msg_documentacao" | translate }}
        </p>

        <h3>🔗 {{ "conclusao.documentos_e_orientacoes" | translate }}</h3>

        <div class="links" >
        <ul>
          @if(_paramData.curso_sem_taxa == false){

            @if(_paramData.fluxo_continuo){

              <li>💵 {{ "conclusao.link1Continuo" | translate }} → <a target="_blank" [href]="url_boleto">{{ "conclusao.download_aqui" | translate }}</a></li>
            }@else {

              <li>💵 {{ "conclusao.link1" | translate }} → <a target="_blank" [href]="url_boleto">{{ "conclusao.download_aqui" | translate }}</a></li>
            }
          }
          <li>📄 {{ "conclusao.link2" | translate }} → <a target="_blank" href="https://www.extecamp.unicamp.br/documentos-extecamp/modelos-curriculos/MODCURR.doc">{{ "conclusao.download_aqui" | translate }}</a></li>
          <li>👤 {{ "conclusao.link3" | translate }} → <a target="_blank" [href]="url_area_aluno">{{ "conclusao.acesse_aqui" | translate }}</a></li>
        </ul>
        </div>
      </div>

    </mat-card-content>
